import React, { Component } from "react"
import './process.scss';
//import LoadingAnimation from '../../components/loadinganimation/verificationloading';
// import LoadingAnimation from '../../components/loadinganimation/paymentloading';
import LoadingAnimation from '../../components/loadinganimation';
import SimpleLoader from '../../components/loadinganimation/simpleloader';
import * as QueryString from "query-string"
import Config from '../../data/SiteConfig';
import ErrorAlert from '../../components/alertmessages';
import { isMobile } from 'react-device-detect';
import { readCashfreePayment, openCashfreeCheckout, cancelCashfreePayment, clearPaymentKeys } from '../../modules/helpers/cashfree';
//import uuid from 'react-uuid';
let mobileNo = '';
let token = '';
let tableNo = '';
let serviceType = '';
let orgnationTd = '';
let propertyId = '';
let outletCode = '';
let paymentInitiatedId = '';
let vendorTransactionId = '';
let vendorId = '';
let vendorName = '';
let totalAmount = 0;
let mainGuestMobileNo = '';
let urlPattern = '';
let outletDetails = '';
export default class ProcessVerification extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            alertMessage: '',
            msgShow: false,
            paymentInitiatedId: "",
            statusMsg: "",
            outLetImage: '',
            cashfreeView: null,
            reason: '',
            refundStatus: '',
            amount: ''
        }
    }

    componentDidMount() {
        this.returnedAt = Date.now();
        if (Config.IsMobileAccess) {
            if (!isMobile) {
                this.props.history.push('/deviceerror' + urlPattern);
                return false;
            }
        }
        outletDetails = sessionStorage.getItem('user-outletDetails');   // Added by vijay 
        const parsedOutletDetails = JSON.parse(outletDetails);
        this.setState({ outLetImage: parsedOutletDetails.outletImageUrl })

        sessionStorage.removeItem('redirect-page');
        let inputParam = QueryString.parse(window.location.search);
        let vendorPaymentStatus = inputParam.payment_status;
        // this.setState({ statusMsg: "Processing Your Request" });
        this.setState({ statusMsg: <div className="status-message">Processing Your Request <span className="running-dots">...</span></div> });
        // console.log(inputParam);

        mobileNo = sessionStorage.getItem('user-mobileno');
        token = sessionStorage.getItem('user-token');
        tableNo = sessionStorage.getItem('user-tableno');
        serviceType = sessionStorage.getItem('user-servicetype');
        orgnationTd = sessionStorage.getItem('user-orgnationid');
        propertyId = sessionStorage.getItem('user-propertyid');
        outletCode = sessionStorage.getItem('user-outletcode');
        mainGuestMobileNo = sessionStorage.getItem('main-guest-no') == null ? '' : sessionStorage.getItem('main-guest-no');

        paymentInitiatedId = sessionStorage.getItem('paymentInitiatedId');
        vendorTransactionId = sessionStorage.getItem('vendorTransactionId');
        vendorId = sessionStorage.getItem('vendorId');
        vendorName = sessionStorage.getItem('vendorName');
        totalAmount = sessionStorage.getItem('payAmount');

        const sessionDt = sessionStorage.getItem("u-l-v-url-dt");
        if (!sessionDt) {
            this.props.history.push('/sessionerror' + urlPattern);
            return false;
        }
        urlPattern = sessionStorage.getItem('url-pattern');
        if (!urlPattern) {
            this.props.history.push('/qrcodeerror' + Config.defaultUrlPattern);
            return false;
        }

        if (token === undefined || token === "" || token === null) {
            this.props.history.push('/' + urlPattern);
            return false;
        }
        if (mobileNo === undefined || mobileNo === "" || mobileNo === null) {
            this.props.history.push('/' + urlPattern);
            return false;
        }
        if (tableNo === undefined || tableNo === "" || tableNo === null) {
            this.props.history.push('/' + urlPattern);
            return false;
        }
        if (serviceType === undefined || serviceType === "" || serviceType === null) {
            this.props.history.push('/' + urlPattern);
            return false;
        }
        if (orgnationTd === undefined || orgnationTd === "" || orgnationTd === null) {
            this.props.history.push('/' + urlPattern);
            return false;
        }
        if (propertyId === undefined || propertyId === "" || propertyId === null) {
            this.props.history.push('/' + urlPattern);
            return false;
        }
        if (outletCode === undefined || outletCode === "" || outletCode === null) {
            this.props.history.push('/' + urlPattern);
            return false;
        }

        if (paymentInitiatedId === undefined || paymentInitiatedId === "" || paymentInitiatedId === null) {
            this.showMessage('Transaction failed. Please try again', "danger");
            this.setState({ loading: true });
            setTimeout(() => { this.props.history.push('/mybills' + urlPattern); }, 2000);
            return false;
        }

        window.scrollTo(0, 0);

        if (vendorPaymentStatus !== null && vendorPaymentStatus !== "Failed") {
            // API Call
            this.handleCheckPaymentStatus();
        }
        else {
            sessionStorage.removeItem("paymentInitiatedId");
            sessionStorage.removeItem("vendorTransactionId");
            sessionStorage.removeItem("vendorId");
            sessionStorage.removeItem("vendorName");
            sessionStorage.removeItem("paymentStatus");
            sessionStorage.removeItem('payAmount');
            this.setState({ loading: false, statusMsg: "Redirecting..." });
            this.showMessage('Transaction failed. Please try again', "danger");
            setTimeout(() => { this.setState({ loading: true }); setTimeout(() => { this.props.history.push('/mybills' + urlPattern); }, Config.minMsgTimeout); }, Config.minMsgTimeout);
        }
    }
    handleCheckPaymentStatus() {
        console.log("calling payment check")
        fetch(Config.baseLUCIDPaymentAPI + 'GetPaymentStatus?PaymentInitiatedId=' + paymentInitiatedId, {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                'content-type': 'application/json'
            }
        })
            .then(res => res.json())
            .then(response => {
                if (response.errorCode === 0) {
                    if (Number(vendorId) === 5) {
                        this.handleCashfreeStatus(response.response);
                        return;
                    }
                    setTimeout(() => {
                        // console.log(response);
                        if (response.response.status === "SUCCESS") {
                            console.log("on way to call settil")
                            if (Number(vendorId) === 4) {
                                setTimeout(() => {
                                    this.setState({ loading: false });
                                    sessionStorage.removeItem("paymentInitiatedId");
                                    sessionStorage.removeItem("vendorTransactionId");
                                    sessionStorage.removeItem("vendorId");
                                    sessionStorage.removeItem("vendorName");
                                    sessionStorage.removeItem("paymentStatus");
                                    sessionStorage.removeItem("payAmount");
                                    sessionStorage.removeItem("order-instruction");
            
                                    //  console.log(response);
                                    this.props.history.push('/processsuccess' + urlPattern,
                                        {
                                            billSuccess: true
                                        });
                                }, Config.minMsgTimeout);
                            }
                            else {
                                this.handleBillandSettle(response.response.vendorTransactionId);
                            }
                        }
                        else if (response.response.status === "PENDING") {
                            console.log("das")
                            setTimeout(() => {
                                this.handleCheckPaymentStatus();
                            }, Config.minMsgTimeout);
                        }
                        else if (response.response.status === "FAILED") {
                            clearPaymentKeys();
                            this.props.history.push('/processfailed' + urlPattern);
                        }
                        else {
                            this.setState({ loading: true });
                            this.setState({ statusMsg: "Transaction failed. Please try again" });
                            this.showMessage('Transaction failed. Please try again', "danger");
                            setTimeout(() => { this.props.history.push('/mybills' + urlPattern); }, Config.minMsgTimeout);
                        }

                        //  window.location.href = response.response.vendorRedirectUrl;

                        // this.props.history.push('/paymentVerification', {
                        //     getMenus: this.state.getMenus,
                        //     getItems: this.state.getItems,
                        //     getModifiers: this.state.getModifiers,
                        //     getTaxes: this.state.getTaxes,
                        //     getCharges: this.state.getCharges
                        // });
                    }, Config.minMsgTimeout);
                }
                else {
                    if (Number(vendorId) === 5) {
                        this.pollLater();
                        return;
                    }
                    this.setState({ loading: true });
                    this.showMessage(response.message, "danger");
                    this.setState({ statusMsg: response.message });
                    setTimeout(() => { this.setState({ loading: false }); this.props.history.push('/mybills' + urlPattern); }, Config.minMsgTimeout);
                }
            })
            .catch(err => {
                // console.log(err);
                if (Number(vendorId) === 5) {
                    this.pollLater();
                    return;
                }
                this.setState({ loading: true });
                this.showMessage('Transaction failed. Please try again', "danger");
                setTimeout(() => { this.setState({ loading: false }); this.props.history.push('/mybills' + urlPattern); }, Config.minMsgTimeout);
            });
    }

    componentWillUnmount() {
        if (this.pollTimer) {
            clearTimeout(this.pollTimer);
        }
    }

    getPaymentStatus = () => {
        this.handleCheckPaymentStatus();
    };

    backPage = () => '/mybills';

    goSuccess = () => {
        this.props.history.push('/processsuccess' + urlPattern, { billSuccess: true });
    };

    handleCashfreeStatus = (r) => {
        const payment = readCashfreePayment();
        if (!payment) return this.props.history.push(this.backPage() + urlPattern);
        if (r.status === 'SUCCESS') {
            if (r.orderStatus === 1) { clearPaymentKeys(); return this.goSuccess(); }
            if (r.orderStatus === 2 || r.orderStatus === 3) {
                clearPaymentKeys();
                return this.setState({ cashfreeView: 'refund', refundStatus: r.refundStatus, amount: payment.amount });
            }
            if (this.state.cashfreeView !== 'placing') {
                this.setState({ cashfreeView: 'placing' });
            }
            return this.pollLater();
        }
        if (r.status === 'FAILED') {
            clearPaymentKeys();
            return this.props.history.push('/processfailed' + urlPattern);
        }
        if (r.status === 'CANCELLED') {
            clearPaymentKeys();
            this.showMessage('Payment cancelled.', 'danger');
            return setTimeout(() => this.props.history.push(this.backPage() + urlPattern), 1500);
        }
        if (Date.now() - payment.startedAt >= 20 * 60 * 1000) return this.cancelCashfree('Payment timed out');
        const reason = r.reason || '';
        if (this.state.cashfreeView !== 'waiting' || this.state.reason !== reason) {
            this.setState({ cashfreeView: 'waiting', reason: reason });
        }
        this.pollLater();
    };

    pollLater = () => {
        const delay = Date.now() - this.returnedAt < 2 * 60 * 1000 ? 3000 : 10000;
        this.pollTimer = setTimeout(() => this.getPaymentStatus(), delay);
    };

    payAgain = () => {
        const p = readCashfreePayment();
        if (p) openCashfreeCheckout(p.vendorKey, p.vendorMode);
    };

    cancelCashfree = (reason) => {
        const p = readCashfreePayment();
        if (!p) return;
        cancelCashfreePayment(p.paymentInitiatedId, reason)
            .then((res) => (res.errorCode === 0 ? this.handleCashfreeStatus(res.response) : this.getPaymentStatus()))
            .catch(() => this.getPaymentStatus());
    };

    handleBillandSettle(venId) {
        console.log("on way to call bill")

        let paymentDetails = [];

        paymentDetails.push({
            PayMode: "ONLP", // Online Pay 
            PaymentAmount: totalAmount,
            TransactionRefId: venId || vendorTransactionId,
            PaymentVendorId: vendorId, // Vendor Id
            PaymentVendorName: vendorName
        });
        console.log({ paymentDetails })

        let postObj = {
            OutletId: propertyId + outletCode,
            ServiceType: serviceType,
            TableNumber: tableNo,
            OrderAmount: totalAmount,
            PaymentDetails: paymentDetails,
            GuestName: sessionStorage.getItem("main-guest-name") === null ? (sessionStorage.getItem("guest-name") === null ? ' ' : sessionStorage.getItem("guest-name")) : sessionStorage.getItem("main-guest-name"),
            //MobileNo: mainGuestMobileNo
            MobileNo: (mainGuestMobileNo === '' || mainGuestMobileNo === "0000000000") ? mobileNo : mainGuestMobileNo
        }
        console.log({ postObj })

        this.setState({ loading: true });

        // console.log(postObj);

        fetch(Config.basePOSUrl + 'BillAndSettle', {
            method: 'POST',
            headers: {
                Authorization: "Bearer " + token,
                'content-type': 'application/json'
            },
            body: JSON.stringify(postObj)
        })
            .then(res => res.json())
            .then(response => {
                if (response.errorCode === 0) {
                    setTimeout(() => {
                        this.setState({ loading: false });
                        sessionStorage.removeItem("paymentInitiatedId");
                        sessionStorage.removeItem("vendorTransactionId");
                        sessionStorage.removeItem("vendorId");
                        sessionStorage.removeItem("vendorName");
                        sessionStorage.removeItem("paymentStatus");
                        sessionStorage.removeItem("payAmount");
                        sessionStorage.removeItem("order-instruction");

                        //  console.log(response);
                        this.props.history.push('/processsuccess' + urlPattern,
                            {
                                billSuccess: true
                            });
                    }, Config.minMsgTimeout);
                }
                else {
                    //  console.log(response.message);
                    this.setState({ loading: true });
                    this.showMessage(response.message, "danger");
                    setTimeout(() => { this.setState({ loading: false }); this.props.history.push('/mybills' + urlPattern); }, 1500);
                }
            })
            .catch(err => {
                //  console.log(err);
                this.setState({ loading: true });
                this.showMessage('Error the bill was not settled', "danger");
                setTimeout(() => { this.setState({ loading: false }); this.props.history.push('/mybills' + urlPattern); }, 1500);
            });
    };

    showMessage(msg, type) {
        window.scrollTo(0, 0);
        this.setState({ msgShow: true });
        this.setState({ msgType: type });
        this.setState({ alertMessage: msg });
        this.setState({ loading: false });
        setTimeout(() => {
            this.setState({ msgShow: false });
        }, Config.minMsgTimeout);
    };

    render() {
        return (
            <div>
                {this.state.loading && <LoadingAnimation />}
                <div id="content" className="top">
                    {this.state.msgShow && <ErrorAlert alertMsg={this.state.alertMessage} msgType={this.state.msgType} msgShow={this.state.msgShow} />}
                    <div className="content-warp">
                        <div className="section-processverification">
                            {/* <div className="heading-page">
                                {sessionStorage.getItem("user-propertyname")}
                                <span className="payment-txt">{sessionStorage.getItem("user-outletname")} - {sessionStorage.getItem("user-servicetype") === "FINE-DINE" ? 'Table Service' : sessionStorage.getItem("user-servicetype")} </span>
                                {/* <div className="back-btn">
                                    <div className="icon-back" onClick={this.goBack}><i className="fas fa-arrow-left" aria-hidden="true"></i></div>
                                </div> */}
                            {/* </div> */}
                            <div className="content-from">
                                <div className="message-details">
                                    <div className="content">
                                        <div className="logo-v2-process-request">
                                            <img style={{ width: "220px", marginLeft: "12px", marginBottom: "30px" }} src={this.state.outLetImage} alt="this.state.outLetImage" />
                                        </div>
                                        {!this.state.cashfreeView && (
                                            <div>
                                                <SimpleLoader />
                                                <div className="msg">{this.state.statusMsg}</div>
                                            </div>
                                        )}

                                        {this.state.cashfreeView === 'waiting' && (
                                            <div className="cashfree-status-box" style={{ textAlign: "center", padding: "10px" }}>
                                                <SimpleLoader />
                                                <h4 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "12px", color: "#212529" }}>Waiting for your payment</h4>
                                                {this.state.reason ? (
                                                    <p style={{ color: "#d9534f", fontSize: "14px", marginBottom: "20px" }}>
                                                        Payment did not go through ({this.state.reason})
                                                    </p>
                                                ) : null}
                                            </div>
                                        )}

                                        {this.state.cashfreeView === 'placing' && (
                                            <div className="cashfree-status-box" style={{ textAlign: "center", padding: "10px" }}>
                                                <SimpleLoader />
                                                <h4 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "12px", color: "#212529" }}>Payment received. Placing your order.</h4>
                                                <div className="msg" style={{ marginTop: "10px" }}><span className="running-dots">...</span></div>
                                                {(() => {
                                                    const p = readCashfreePayment();
                                                    if (p && Date.now() - p.startedAt >= 5 * 60 * 1000) {
                                                        return (
                                                            <p style={{ color: "#856404", backgroundColor: "#fff3cd", border: "1px solid #ffeeba", borderRadius: "5px", padding: "10px", fontSize: "13px", marginTop: "20px" }}>
                                                                This is taking longer than usual. Do not pay again.
                                                            </p>
                                                        );
                                                    }
                                                    return null;
                                                })()}
                                            </div>
                                        )}

                                        {this.state.cashfreeView === 'refund' && (
                                            <div className="cashfree-status-box" style={{ textAlign: "center", padding: "10px" }}>
                                                <h4 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "12px", color: "#d9534f" }}>We could not place your order. ₹{this.state.amount} will be refunded in full.</h4>
                                                <p style={{ fontSize: "14px", color: "#555", marginTop: "12px" }}>
                                                    {this.state.refundStatus === 'SUCCESS'
                                                        ? `₹${this.state.amount} refunded`
                                                        : this.state.refundStatus === 'FAILED'
                                                        ? 'Refund delayed. Please contact the outlet.'
                                                        : `Refund of ₹${this.state.amount} started`}
                                                </p>
                                                <button
                                                    type="button"
                                                    style={{ backgroundColor: "#201358", color: "#fff", border: "none", padding: "12px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "16px", fontWeight: "500", marginTop: "20px", width: "100%" }}
                                                    onClick={() => this.props.history.push(this.backPage() + urlPattern)}>
                                                    Back to Open Orders
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}